import { z } from 'zod'

export const datetimeSchema = z.string().datetime().pipe(z.coerce.date())
